import { render, staticRenderFns } from "./OtoEditButton.vue?vue&type=template&id=7a66675c&scoped=true"
import script from "./OtoEditButton.vue?vue&type=script&lang=js"
export * from "./OtoEditButton.vue?vue&type=script&lang=js"
import style0 from "./OtoEditButton.vue?vue&type=style&index=0&id=7a66675c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a66675c",
  null
  
)

export default component.exports